import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

/**
 * Generated class for the FormatDatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'parseReplaceDatetime',
})
export class ParseReplaceDatetimePipe implements PipeTransform {
  transform(description: string, endTime: string): string {
    if (!description || !endTime) {
      return description;
    }

    // Validate that endTime is an ISO string format
    const parsedDate = new Date(endTime);
    if (isNaN(parsedDate.getTime())) {
      return description;
    }

    // Convert the date to Central Standard Time (CST)
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Chicago',
    }).format(parsedDate);

    // Replace <% XX:XX %> with the formatted time
    return description.replace(/<%\s*XX:XX\s*%>/g, formattedTime);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/parse-replace-datetime/parse-replace-datetime.ts